import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Grid, Row, Column } from '@lux/components';
import { Caption, FootnoteSecondary } from '../Base';
import Spacing from '../Spacing';
import Anchor from '../Anchor';

const StyledFooter = styled.footer`
  color: ${p => p.theme.colours.grey_600};
  padding-top: ${p => p.theme.spacing(1)};
  padding-bottom: ${p => p.theme.spacing(3)};
  ${p => p.theme.media.md`
  padding: ${p => p.theme.spacing(2)} 0;
  `};
  background-color: ${p => p.theme.colours.white};
  border-top: 1px solid ${p => p.theme.colours.grey_400};
`;

const Links = styled(FootnoteSecondary)`
  text-align: center;
  ${p => p.theme.media.md`
  text-align: left;
  `};
`;

const Link = styled(Anchor)`
  display: block;
  padding: ${p => p.theme.spacing(2)} 0;
  ${p => p.theme.media.md`
  display: inline-block;
  margin-right: ${p => p.theme.spacing(2)};
  padding: 0;
  `};
  margin-right: 0;
  cursor: pointer;
`;

const StyledCaption = styled(Caption)`
  color: ${p => p.theme.colours.grey_600};
`;

const CopyrightText = styled(FootnoteSecondary)`
  text-align: center;
  ${p => p.theme.media.md`
  text-align: right;
  `};
`;

const CookieText = styled(FootnoteSecondary)`
  text-align: center;
  ${p => p.theme.media.md`
  text-align: left;
  `};
`;

const Footer = props => {
  const { links, cookieText, copyrightText } = props;

  return (
    <StyledFooter className="fs-unmask">
      <Grid>
        <Row>
          <Column>
            <Spacing bottom={1} bottomMd={0}>
              <Row center="sm" between="md" middle="sm">
                <Column sm={12} md={6}>
                  <Links>
                    {links.map(({ text, link }, key) => (
                      <Link
                        key={key}
                        href={link}
                        target="_blank"
                        rel="noopener"
                      >
                        <StyledCaption>{text}</StyledCaption>
                      </Link>
                    ))}
                  </Links>
                </Column>
                <Column sm={12} md={6}>
                  <CopyrightText>{copyrightText}</CopyrightText>
                </Column>
              </Row>
            </Spacing>
            <Spacing top={1} topMd={0}>
              <Row center="sm" start="md">
                <Column sm={12}>
                  <CookieText>{cookieText}</CookieText>
                </Column>
              </Row>
            </Spacing>
          </Column>
        </Row>
      </Grid>
    </StyledFooter>
  );
};

Footer.propTypes = {
  /* Sets the array of links */
  links: PropTypes.arrayOf(
    PropTypes.shape({
      /* The text to display for the link */
      text: PropTypes.string,
      /* The link for navigation */
      link: PropTypes.string
    })
  ),
  /* Sets the cookie policy text */
  cookieText: PropTypes.node,
  /* Sets the copyright text */
  copyrightText: PropTypes.string
};

export default Footer;
